module.exports = __webpack_public_path__ + "static/img/e4985ad5d46bee8dd0ce3d23e0d4ed9b.50a2d59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/e4985ad5d46bee8dd0ce3d23e0d4ed9b.jpg
// module id = o4e8
// module chunks = 4